import * as React from 'react';
import { useQuery } from '@apollo/client';
import { userQuery } from '../../graphql/queries';
import LoadingSpinner from '../../components/LoadingSpinner';
import { ResponsiveTable } from '../../components/Layout';

type AchievementsProps = {
  pickpackId: string | null;
};

export const AchievementsTab = function AchievementsTab({
  pickpackId,
}: AchievementsProps) {
  if (pickpackId == null) {
    return <span>No pickpack id for user</span>;
  }

  const { data, loading } = useQuery(userQuery, {
    variables: { id: pickpackId },
  });

  return (
    <div>
      <h4>Achievements</h4>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <ResponsiveTable>
          <thead>
            <tr>
              <th>Id</th>
              <th>Unlocked At</th>
            </tr>
          </thead>
          <tbody>
            {((data || { user: {} }).user.unlocked_achievements || []).map(
              (achievement: any) => {
                return (
                  <tr key={achievement.id}>
                    <td>{achievement.id}</td>
                    <td>{achievement.unlocked_at}</td>
                  </tr>
                );
              },
            )}
          </tbody>
        </ResponsiveTable>
      )}
    </div>
  );
};
